import { render, staticRenderFns } from "./IconMobilePhone.vue?vue&type=template&id=5c1c8c4c&"
import script from "./IconMobilePhone.vue?vue&type=script&lang=js&"
export * from "./IconMobilePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports